import { useState, useEffect } from 'react';
import { UseDebounceOptions } from './useDebounce.types';

export function useDebounce<T>(value: T, options: UseDebounceOptions = {}): T {
    const { delay = 500, immediate = false } = options;
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        if (immediate) return setDebouncedValue(value);

        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(timer);
        };
    }, [value, delay, immediate]);

    return debouncedValue;
} 